// lib/filters/parseAutoImportLink

var name = 'auto-import';
var link = 'auto-import';

function parseLink(name = null, parseLink = null) {
    return function (number, dataset) {
        if (number) number = number.trim();
        var link = parseLink + '/' + number;
        var data = dataset || {};
        data.name = name;
        data = JSON.stringify(data);
        let txt = ["Редактировать заявку", "Редактировать заявку", 'Редактировать заявку'];
        return `<a data-data='${data}' href="${link}">${txt[dataset.status]}</a>`
    }
}

export default {filters: { parseAutoImportLink: parseLink(name, link)} }



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseAutoImportLink.js
 **/